import React from 'react'

import { Helmet } from 'react-helmet'

import './programs.css'

const Programs = (props) => {
  return (
    <div className="programs-container">
      <Helmet>
        <title>
          FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
      </Helmet>
      <div className="programs-programs">
        <div className="programs-frame121">
          <div className="programs-frame15">
            <div className="programs-frame162">
              <img
                alt="VectorI372"
                src="/external/vectori372-w45c.svg"
                className="programs-vector10"
              />
              <span className="programs-text10">futureheirs</span>
            </div>
            <div className="programs-frame81">
              <div className="programs-frame6">
                <span className="programs-text11">Home</span>
              </div>
              <div className="programs-frame7">
                <span className="programs-text12">About Us</span>
              </div>
              <div className="programs-frame82">
                <span className="programs-text13">Contact Us</span>
              </div>
              <div className="programs-frame9">
                <span className="programs-text14">Blog</span>
              </div>
            </div>
            <div className="programs-component41">
              <span className="programs-text15">Join Us</span>
            </div>
          </div>
          <div className="programs-frame132">
            <div className="programs-frame195">
              <img
                alt="Line651782"
                src="/external/line651782-84cd.svg"
                className="programs-line65"
              />
              <span className="programs-text16">Our Programs</span>
            </div>
            <span className="programs-text17">
              Explore our programs designed to equip students with education,
              technology, and leadership skills to create a brighter future.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle41782"
          src="/external/rectangle41782-dh4n.svg"
          className="programs-rectangle4"
        />
        <div className="programs-frame234">
          <div className="programs-frame230">
            <div className="programs-frame2161">
              <span className="programs-text18">
                Tailored Learning for Every Stage of Growth
              </span>
              <span className="programs-text19">
                From early education to career readiness, our programs equip
                students with the knowledge, skills, and values they need to
                succeed.
              </span>
            </div>
            <div className="programs-component3">
              <div className="programs-component2">
                <div className="programs-frame219">
                  <span className="programs-text20">
                    Elementary Foundations
                  </span>
                </div>
                <div className="programs-frame220">
                  <span className="programs-text21">
                    Middle School Exploration
                  </span>
                </div>
                <div className="programs-frame221">
                  <span className="programs-text22">
                    High School Preparation
                  </span>
                </div>
                <div className="programs-frame222">
                  <span className="programs-text23">Young Adult Mentoring</span>
                </div>
              </div>
              <div className="programs-frame225">
                <img
                  alt="Rectangle10I194"
                  src="/external/rectangle10i194-kr6b-500w.png"
                  className="programs-rectangle10"
                />
                <div className="programs-frame224">
                  <div className="programs-frame218">
                    <span className="programs-text24">
                      Elementary Foundations (Ages 6-11)
                    </span>
                    <span className="programs-text25">
                      Building strong academic foundations while nurturing
                      curiosity, creativity, and character. Our elementary
                      programs introduce basic tech skills, biblical values, and
                      collaborative learning in age-appropriate ways.
                    </span>
                  </div>
                  <div className="programs-faq">
                    <div className="programs-frame197">
                      <div className="programs-frame2001">
                        <span className="programs-text26">
                          Introduction to basic tech skills.
                        </span>
                        <span className="programs-text27">
                          Children are introduced to technology through fun,
                          interactive activities that build digital literacy and
                          problem-solving abilities.
                        </span>
                      </div>
                      <div className="programs-vuesaxboldminuscirlce1">
                        <div className="programs-vuesaxboldminuscirlce2">
                          <div className="programs-minuscirlce">
                            <img
                              alt="VectorI194"
                              src="/external/vectori194-3iip.svg"
                              className="programs-vector11"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="programs-frame198">
                      <div className="programs-frame2002">
                        <span className="programs-text28">
                          Age-appropriate biblical values.
                        </span>
                      </div>
                      <div className="programs-vuesaxboldaddcircle1">
                        <div className="programs-vuesaxboldaddcircle2">
                          <div className="programs-addcircle1">
                            <img
                              alt="VectorI194"
                              src="/external/vectori194-hi1q.svg"
                              className="programs-vector12"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="programs-frame199">
                      <div className="programs-frame2003">
                        <span className="programs-text29">
                          Hands-on, collaborative learning.
                        </span>
                      </div>
                      <div className="programs-vuesaxboldaddcircle3">
                        <div className="programs-vuesaxboldaddcircle4">
                          <div className="programs-addcircle2">
                            <img
                              alt="VectorI194"
                              src="/external/vectori194-c5sj.svg"
                              className="programs-vector13"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="programs-frame2162">
            <div className="programs-frame231">
              <div className="programs-frame232">
                <span className="programs-text30">
                  Start Your Journey with FutureHeirs
                </span>
                <span className="programs-text31">
                  No matter where you are on your learning journey, we’re here
                  to guide you toward success.
                </span>
              </div>
              <div className="programs-frame233">
                <div className="programs-component42">
                  <span className="programs-text32">Enroll now</span>
                </div>
                <span className="programs-text33">Learn more</span>
              </div>
            </div>
          </div>
          <div className="programs-component5">
            <div className="programs-frame140">
              <span className="programs-text34">Our Programs</span>
              <div className="programs-frame131">
                <img
                  alt="Frame130I253"
                  src="/external/frame130i253-1q29.svg"
                  className="programs-frame130"
                />
                <img
                  alt="Frame109I253"
                  src="/external/frame109i253-hemt.svg"
                  className="programs-frame109"
                />
              </div>
            </div>
            <div className="programs-frame139">
              <div className="programs-frame135">
                <img
                  alt="Rectangle3I253"
                  src="/external/rectangle3i253-ufs2-200h.png"
                  className="programs-rectangle31"
                />
                <div className="programs-frame1341">
                  <span className="programs-text35">
                    Online Learning Academy
                  </span>
                  <span className="programs-text36">
                    Our digital platform makes quality, faith-integrated
                    education...
                  </span>
                </div>
                <div className="programs-component43">
                  <span className="programs-text37">Learn more</span>
                </div>
              </div>
              <div className="programs-frame138">
                <img
                  alt="Rectangle3I253"
                  src="/external/rectangle3i253-5qta-200h.png"
                  className="programs-rectangle32"
                />
                <div className="programs-frame1342">
                  <span className="programs-text38">
                    Tech Innovation Centers
                  </span>
                  <span className="programs-text39">
                    Hands-on learning spaces where students develop practical...
                  </span>
                </div>
                <div className="programs-component44">
                  <span className="programs-text40">Learn more</span>
                </div>
              </div>
              <div className="programs-frame137">
                <img
                  alt="Rectangle3I253"
                  src="/external/rectangle3i253-pb8n-200h.png"
                  className="programs-rectangle33"
                />
                <div className="programs-frame1343">
                  <span className="programs-text41">
                    Community Learning Hubs
                  </span>
                  <span className="programs-text42">
                    Physical spaces within underserved communities...
                  </span>
                </div>
                <div className="programs-component45">
                  <span className="programs-text43">Learn more</span>
                </div>
              </div>
              <div className="programs-frame136">
                <img
                  alt="Rectangle3I253"
                  src="/external/rectangle3i253-hmp-200h.png"
                  className="programs-rectangle34"
                />
                <div className="programs-frame1344">
                  <span className="programs-text44">
                    Leadership Development
                  </span>
                  <span className="programs-text45">
                    Beyond academics and technical skills, we invest in
                    cultivating...
                  </span>
                </div>
                <div className="programs-component46">
                  <span className="programs-text46">Learn more</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="programs-frame217">
          <div className="programs-frame190">
            <div className="programs-group39">
              <img
                alt="Rectangle19304"
                src="/external/rectangle19304-en8r-1100w.png"
                className="programs-rectangle1"
              />
              <div className="programs-grid">
                <div className="programs-group34">
                  <img
                    alt="Line519304"
                    src="/external/line519304-gmrb.svg"
                    className="programs-line51"
                  />
                  <img
                    alt="Line529304"
                    src="/external/line529304-zdqk.svg"
                    className="programs-line52"
                  />
                  <img
                    alt="Line539304"
                    src="/external/line539304-c1s.svg"
                    className="programs-line53"
                  />
                  <img
                    alt="Line549304"
                    src="/external/line549304-feu.svg"
                    className="programs-line54"
                  />
                  <img
                    alt="Line559304"
                    src="/external/line559304-h9t9.svg"
                    className="programs-line55"
                  />
                  <img
                    alt="Line569304"
                    src="/external/line569304-hfj8.svg"
                    className="programs-line56"
                  />
                  <img
                    alt="Line579304"
                    src="/external/line579304-8w0g.svg"
                    className="programs-line57"
                  />
                </div>
                <div className="programs-group33">
                  <img
                    alt="Line369304"
                    src="/external/line369304-zd2a.svg"
                    className="programs-line36"
                  />
                  <img
                    alt="Line379304"
                    src="/external/line379304-btdk.svg"
                    className="programs-line37"
                  />
                  <img
                    alt="Line389304"
                    src="/external/line389304-coy.svg"
                    className="programs-line38"
                  />
                  <img
                    alt="Line399304"
                    src="/external/line399304-87x.svg"
                    className="programs-line39"
                  />
                </div>
              </div>
              <img
                alt="childrenelectronicdevicesgadgetsconceptsmartconfid9304"
                src="/external/childrenelectronicdevicesgadgetsconceptsmartconfid9304-6k0w-500h.png"
                className="programs-childrenelectronicdevicesgadgetsconceptsmartconfid"
              />
            </div>
            <div className="programs-frame122">
              <div className="programs-frame133">
                <span className="programs-text47">
                  Subscribe to our Newsletter
                </span>
                <span className="programs-text48">
                  Join our community of supporters and stay updated on how
                  we&apos;re empowering the next generation of leaders.
                </span>
              </div>
              <div className="programs-cta">
                <div className="programs-frame3">
                  <span className="programs-text49">example@gmail.com</span>
                </div>
                <div className="programs-component47">
                  <span className="programs-text50">Subscribe</span>
                </div>
              </div>
            </div>
          </div>
          <div className="programs-frame189">
            <div className="programs-frame184">
              <div className="programs-group107">
                <span className="programs-text51">Company</span>
                <div className="programs-frame2491">
                  <span className="programs-text52">Home</span>
                  <span className="programs-text53">About Us</span>
                  <span className="programs-text54">Contact Us</span>
                  <span className="programs-text55">Programs</span>
                  <span className="programs-text56">Approach</span>
                </div>
              </div>
              <div className="programs-group106">
                <span className="programs-text57">Quick Links</span>
                <div className="programs-frame2492">
                  <span className="programs-text58">Partner with Us</span>
                  <span className="programs-text59">Volunteer</span>
                  <span className="programs-text60">Donate</span>
                  <span className="programs-text61">Blog</span>
                </div>
              </div>
              <div className="programs-group105">
                <span className="programs-text62">Terms and Policies</span>
                <div className="programs-frame248">
                  <span className="programs-text63">Privacy Policy</span>
                  <span className="programs-text64">Terms and Conditions</span>
                  <span className="programs-text65">Feedback</span>
                  <span className="programs-text66">FAQs</span>
                </div>
              </div>
              <div className="programs-group104">
                <span className="programs-text67">Contact Information</span>
                <div className="programs-group87">
                  <span className="programs-text68">
                    connect@futureheirs.org
                  </span>
                  <div className="programs-vuesaxboldsms1">
                    <div className="programs-vuesaxboldsms2">
                      <div className="programs-sms">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-s2bq.svg"
                          className="programs-vector14"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="programs-group88">
                  <span className="programs-text69">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="programs-vuesaxboldlocation1">
                    <div className="programs-vuesaxboldlocation2">
                      <img
                        alt="VectorI208"
                        src="/external/vectori208-9p0e.svg"
                        className="programs-vector15"
                      />
                    </div>
                  </div>
                </div>
                <div className="programs-group89">
                  <span className="programs-text70">(555) 123-4567</span>
                  <div className="programs-vuesaxboldcall1">
                    <div className="programs-vuesaxboldcall2">
                      <div className="programs-call">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-fdyd.svg"
                          className="programs-vector16"
                        />
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-v18i.svg"
                          className="programs-vector17"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I208"
              src="/external/line2i208-qv5.svg"
              className="programs-line2"
            />
            <div className="programs-frame183">
              <div className="programs-frame161">
                <img
                  alt="VectorI208"
                  src="/external/vectori208-qkuk.svg"
                  className="programs-vector18"
                />
                <span className="programs-text71">futureheirs</span>
              </div>
              <div className="programs-frame180">
                <span className="programs-text72">Follow Us:</span>
                <div className="programs-frame177">
                  <div className="programs-vuesaxboldfacebook1">
                    <div className="programs-vuesaxboldfacebook2">
                      <div className="programs-facebook">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-6p7.svg"
                          className="programs-vector19"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI208"
                    src="/external/riinstagramfilli208-ue6.svg"
                    className="programs-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI208"
                    src="/external/pajamaslinkedini208-uqz.svg"
                    className="programs-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI208"
                    src="/external/fa6brandssquarextwitteri208-g8ce.svg"
                    className="programs-fa6brandssquarextwitter"
                  />
                  <div className="programs-vuesaxboldyoutube1">
                    <div className="programs-vuesaxboldyoutube2">
                      <div className="programs-youtube">
                        <img
                          alt="VectorI208"
                          src="/external/vectori208-dzal.svg"
                          className="programs-vector20"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Programs
